import Vue from 'vue'
import VueI18n from 'vue-i18n'
import LocaleJa from '@/i18n/locales/ja.json'
import LocaleEn from '@/i18n/locales/en.json'
import LocaleZh from '@/i18n/locales/zh.json'
import LocaleZhtw from '@/i18n/locales/zhtw.json'
import LocaleKo from '@/i18n/locales/ko.json'

Vue.use(VueI18n)

let findDefaultLocale = () => {
  let lang =
    (window.navigator.languages && window.navigator.languages[0])
    || window.navigator.language
    || window.navigator.userLanguage
    || window.navigator.browserLanguage

  if (!lang) { return 'en' }
  if (lang.includes('-')) { return lang.split('-')[0] }
  return lang
}

const defaultDateTimeFormat = {
  short: {
    year: 'numeric', month: 'short', day: 'numeric', weekday: 'short'
  },
  long: {
    year: 'numeric', month: 'short', day: 'numeric', weekday: 'short',
    hour: 'numeric', minute: 'numeric'
  }
}

export default new VueI18n({
  locale: findDefaultLocale(),
  fallbackLocale: 'en',
  messages: {
    ja: LocaleJa,
    en: LocaleEn,
    zh: LocaleZh,
    zhtw: LocaleZhtw,
    ko: LocaleKo
  },
  dateTimeFormats: {
    ja: defaultDateTimeFormat,
    en: defaultDateTimeFormat,
    zh: defaultDateTimeFormat,
    zhtw: defaultDateTimeFormat,
    ko: defaultDateTimeFormat
  }
})
